var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgLabel = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 21 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.281 6a1 1 0 1 0 2 0 1 1 0 0 0-2 0Zm6.71-.71-5-5a1 1 0 0 0-.71-.29h-11a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h11a.999.999 0 0 0 .71-.29l5-5a.998.998 0 0 0 0-1.42ZM13.871 10H3.281a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h10.59l4 4-4 4Z",
  fill: "currentColor"
})));

export default SvgLabel;